import React from "react"
import styled from "styled-components"

export const ContentItemHeader = styled.div`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.5em;
  line-height: 1;
  /* or 83% */

  text-transform: uppercase;

  color: #ffffff;

  margin-bottom: 8px;
`

export const ContentItemBody = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2em;
  /* line-height: 42px; */
  /* or 117% */

  color: #ffffff;
`

const ContentItem = props => {
  return (
    <>
      <ContentItemHeader>{props.title}</ContentItemHeader>
      <ContentItemBody>{props.children}</ContentItemBody>
    </>
  )
}

export default ContentItem
